export default {
    topics: [
        {
            title: ' logInfo ',
            href: 'f-logInfo.html',
            attributes: { 'data-id': 'f-logInfo' },
            menu: { hasChildren: false },
            tocID: 'f-logInfo-d66e4518',
            topics: [],
        },
        {
            title: ' logVerbose ',
            href: 'f-logVerbose.html',
            attributes: { 'data-id': 'f-logVerbose' },
            menu: { hasChildren: false },
            tocID: 'f-logVerbose-d66e4526',
            topics: [],
        },
        {
            title: ' logWarning ',
            href: 'f-logWarning.html',
            attributes: { 'data-id': 'f-logWarning' },
            menu: { hasChildren: false },
            tocID: 'f-logWarning-d66e4534',
            topics: [],
        },
        {
            title: ' logError ',
            href: 'f-logError.html',
            attributes: { 'data-id': 'f-logError' },
            menu: { hasChildren: false },
            tocID: 'f-logError-d66e4542',
            topics: [],
        },
    ],
};

